<template>
  <div>
    <b-alert variant="success" show v-if="recipe.status == 0"><strong>Uppskrift móttekin.</strong> Við græjum uppskriftina við fyrsta tækifæri og höfum hana tilbúna fyrir þig.</b-alert>
    <b-container v-if="recipe.name" class="recipe">
      <b-row>
        <b-col>
          <h1>{{ recipe.name }}</h1>
          {{ recipe.comment }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="heading">Dags</span><br>
          <span class="details">{{ recipe.date }}</span>
        </b-col>
        <b-col>
          {{ recipe.author_name }}<br>
          Staða: {{ recipe.status==1?'Útprentuð':recipe.status==0?'Móttekin':'Afgreidd' }}<br>
          Tilbúin: {{ recipe.ready_date }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small :items="recipe.recipe" :fields="recipeFields" foot-clone>
            <template #foot(price)>{{ price }}</template>
            <template #foot()></template>
            <template #cell(price)="data">{{ Math.round(data.item.qty * data.item.price) }}</template>
          </b-table></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="orderRecipe" class="align-middle">Panta uppskrift aftur</b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="changeRecipe" class="align-middle">Breyta uppskrift og panta</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>Panta uppskrift án breytinga. T.d. ef þú vilt panta eins uppskrift aftur.</b-col>
        <b-col>Senda uppskrift í uppskriftavél svo þú getir breytt henni áður en þú pantar.</b-col>
      </b-row>
      <b-modal ref="confirmModal" hide-footer title="Panta uppskrift" @exit="hideModal">
        <confirm-recipe-dialog />
      </b-modal>

    </b-container>
    <b-container v-else>
      <h1>Uppskrift fannst ekki</h1>
      Þessi uppskrift er ekki til.
    </b-container>
    <b-container>
      <hr>
      Uppskriftavél brew.is
    </b-container>
  </div>
</template>

<script>

import ConfirmRecipeDialog from './ConfirmRecipeDialog.vue'

export default {
  name: 'Recipe',
  components: { ConfirmRecipeDialog },
  props: ['recipe_id'],
  data () {
    return {
      text: '',
      values: [],
      recipe: [],
      recipeFields: [
        {key: 'name', label: 'Nafn', thClass: 'text-left', tdClass: 'text-left'},
        {key: 'qty', 'label': 'Magn', thClass: 'text-right', tdClass: 'text-right'},
        {key: 'price', 'label': 'Verð', thClass: 'text-right', tdClass: 'text-right'},
      ]
    }
  },
  methods: {
    orderRecipe: function() {
      // Order exact same recipe again.
      this.$root.state.recipe = this.recipe.recipe
      this.$root.state.recipeName = this.recipe.name
      this.$refs['confirmModal'].show();
    },
    changeRecipe: function() {
      // Person wants to order this recipe, but maybe change it
      this.$root.state.recipe=[]
      this.$root.state.recipeText = ''
      this.recipe.recipe.forEach(e=> {
        this.$root.state.recipeText += e.qty + ' ' + e.name + '\n'
      })
      
      this.$router.push({path: '/'})
      this.$emit('exit')
    },
    hideModal: function() {
      this.$refs['confirmModal'].hide();
    }
  },
  computed: {
    price: function () {
      let total = 0
      this.recipe.recipe.forEach((e) => total += parseFloat(e.qty) * parseInt(e.price))
      return Math.round(total)
    }
  },
  watch: {
    recipe_id: {
      handler: function () {
      let self = this;
      fetch('https://www.brew.is/uppskriftir/getrecipe.php?id='+this.$route.params.id)
        .then((resp) => resp.json())
        .then(function (response) {
          self.recipe = response.res;
        })
      },
      immediate: true
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recipe {
    margin: auto;
    width: 100%;
    max-width: 500px;
    padding: 4vh 2em;
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top: 3px solid rgb(47, 44, 187);
    border-bottom: 3px solid rgb(47, 44, 187);
    border-left: none;
    border-right: none
}
</style>
